// as a percentage
const additionalDiscountForUsdt = {
  percentage: 5,
  coefficient: 0.95,
};

export { additionalDiscountForUsdt };
